module.exports = __webpack_public_path__ + "static/media/wallet.525d8c43.svg";